import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_process_template_machine_link_RowClass} from '../../dbschema';

export class MrpProcessTemplateMachineLinkContainerModel extends BaseContainerModel {
    bl_mrp_process_template_machine_link: bl_mrp_process_template_machine_link_RowClass = new bl_mrp_process_template_machine_link_RowClass();
}
